export default {
      id: "arrow-statistic-usage",
      viewBox: "0 0 12 7",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow-statistic",
      toString: function () {
        return this.url;
      }
    }